import React, {Suspense} from "react";
import {Switch} from "react-router-dom";
import {LayoutSplashScreen, ContentRoute} from "../../../_metronic/layout";
import {UnpaidAgentsPage} from './pages/UnpaidAgentsPage';

export default function RegistrationDataListPage() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <ContentRoute path="/unpaid-agents" component={UnpaidAgentsPage} />
            </Switch>
        </Suspense>
    );
}
